import { Pressable, Text, View } from 'react-native'
import { Spinner } from '@/src/components/ui/Spinner'
import { colors } from '@/src/theme'
import { label2 } from '@/src/theme/typography'

import { NON_SCALING_TEXT_PROPS } from './constants'

interface PostPaymentOnboardingScreenHeaderProps {
  isSigningOut: boolean
  onSignOut: () => void
  logoutLabel: string
}

export function PostPaymentOnboardingScreenHeader({
  isSigningOut,
  onSignOut,
  logoutLabel,
}: PostPaymentOnboardingScreenHeaderProps) {
  return (
    <View className="flex-row items-center justify-between mb-2">
      <View className="flex-1" />
      <Pressable
        onPress={onSignOut}
        disabled={isSigningOut}
        className="active:opacity-60"
      >
        {isSigningOut ? (
          <Spinner size="small" color={colors.textBody} />
        ) : (
          <Text
            {...NON_SCALING_TEXT_PROPS}
            style={{
              ...label2,
              color: colors.textBody,
            }}
          >
            {logoutLabel}
          </Text>
        )}
      </Pressable>
    </View>
  )
}
